import { Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IColumnHeaderProps {
  primaryText: string
  id?: string
  secondaryText?: string
  thirdText?: string
}

export const ColumnHeader = React.memo(({ primaryText, id, secondaryText, thirdText }: IColumnHeaderProps) => (
  <FlexBox vertical ai="start" sx={{ height: "3rem" }}>
    <Typography
      id={typeof id === "string" ? `${id}-primary-text` : undefined}
      color="textPrimary"
      fontSize=".9rem"
      fontWeight={500}
      noWrap>
      {primaryText}
    </Typography>
    {secondaryText && (
      <Typography
        id={typeof id === "string" ? `${id}-secondary-text` : undefined}
        color={thirdText ? "textPrimary" : "textSecondary"}
        fontSize=".75rem"
        noWrap>
        {secondaryText}
      </Typography>
    )}
    {thirdText && (
      <Typography
        id={typeof id === "string" ? `${id}-third-text` : undefined}
        color="textSecondary"
        fontSize=".7rem"
        noWrap>
        {thirdText}
      </Typography>
    )}
  </FlexBox>
))
